"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdmin = exports.isAdminPermission = void 0;
const isAdminPermission = (permission) => {
    return permission.kind === 'admin';
};
exports.isAdminPermission = isAdminPermission;
const isAdmin = (jwt) => jwt.permissions.some(exports.isAdminPermission);
exports.isAdmin = isAdmin;
